// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { AppShell } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { IconInbox } from '@tabler/icons';
import { WindowContext } from '../../Service/Context/WindowContext';
import DoubleNavbar from '../../Molecules/DoubleNavbar';
import PageHeader from '../Navigation/PageHeader';
import { RoutingS } from '../../Service/RoutingS';
import NavDrawer from '../../Atoms/NavDrawer';
import BookitupFooter from '../Navigation/phone/BookitupFooter';
import InboxPageFooter from '../Navigation/phone/InboxPageFooter';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import EmailPageFooter from '../Navigation/phone/EmailPageFooter';
import EmailInboxNavLinks from './EmailInboxNavLinks';

const EmailInboxPage = () => {
  const { sm } = useContext(WindowContext);
  const [drawerOpened, setDrawerOpened] = useState(false);
  const { selectedMessage } = useContext(EmailBoxContext);

  useEffect(() => {
    RoutingS.changeTitle('Postfach');
  }, []);

  return (
    <AppShell
      header={<PageHeader />}
      navbar={
        sm ? undefined : (
          <DoubleNavbar>
            <EmailInboxNavLinks closeNavBar={() => setDrawerOpened(false)} />
          </DoubleNavbar>
        )
      }
      styles={(theme) => ({
        main: {
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'inherit',
          width: '100%',
        },
      })}
      footer={
        sm ? (
          <BookitupFooter>
            {selectedMessage ? <EmailPageFooter /> : <InboxPageFooter filter={() => setDrawerOpened(true)} />}
          </BookitupFooter>
        ) : undefined
      }
    >
      {sm && (
        <NavDrawer
          label="Postfächer"
          icon={<IconInbox size={32} />}
          opened={drawerOpened}
          onClose={() => setDrawerOpened(false)}
        >
          <EmailInboxNavLinks closeNavBar={() => setDrawerOpened(false)} />
        </NavDrawer>
      )}
      <Outlet />
    </AppShell>
  );
};

export default EmailInboxPage;
